import { useOktaAuth } from "@okta/okta-react";
import { SearchBox } from "./SearchBox";

/** The brand, global search, and the signed-in account with its sign-out. */
export function TopBar() {
  const { authState, oktaAuth } = useOktaAuth();
  const email = authState?.idToken?.claims?.email as string | undefined;

  return (
    <header className="topbar">
      <div className="topbar__brand">ANANSI</div>
      <SearchBox />
      <div className="topbar__user">
        <span className="topbar__email mono">{email ?? "…"}</span>
        <button
          className="topbar__signout uppercase-label"
          onClick={() => oktaAuth.signOut()}
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
